import markerSDK from "@marker.io/browser";

import { viteEnv } from "utils/vite-env.util";

let widget: any;
export default async function setupMarkerIO() {
  if (viteEnv.VITE_ENV !== "local") {
    widget = await markerSDK.loadWidget({
      project: viteEnv.VITE_MARKER_PROJECT_ID!
    });
  }
}

export { widget };
